<section class="section-pd">
    <div class="trinka_container">
        <div class="secure-wrapper">
            <div class="row align-items-center match-box">
                <div class="col-md-6 col-lg-6 dflex">
                    <div class="trinka-title mb-0">
                        <h2>安全、可信賴的選擇</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p class="mb-2">Trinka 將資料安全與隱私保護放在首位。您的所有資料皆經高度加密並安全儲存，僅您本人可存取，且可隨時從個人後台中刪除。</p>
                        <p class="mb-30">高級帳號資料會在每 90 天自動從所有系統中刪除。為了進一步提升安全性並符合相關規範，我們提供多種選項，例如「敏感資料方案」，幫助你更全面守護個人隱私。</p>
                        <div class="btn-group">
                            <a href="/data-security" class="filled-btn">了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 dflex ">
                    <div class="text-center">
                        <!-- <picture>
                            <source srcset="../../../assets/images/homepage/data-security.webp" type="image/webp">
                            <img src="../../../assets/images/homepage/data-security.jpg" loading="lazy" decoding="async" alt="data-security">
                        </picture> -->
                        <img src="../../../assets/images/homepage/data-security.svg" class="img-fluid" loading="lazy" decoding="async" width="400" height="307" alt="data-security">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>